<app-pencil-button
  *ngIf="(isSwitcherEnabled$ | async) && (currentSpaceId$ | async)"
  icon="chevrons-left"
  [iconConfig]="{ type: IconTypes.lucideIcon }"
  [theme]="PencilButtonThemeEnum.ICON"
  buttonType="button"
  [attr.aria-label]="'Collapse sidebar' | translate"
  (clickEvent)="collapseSidebar()"
></app-pencil-button>
